// const url = "https://apai.indicchain.com"; // Live
let url = "https://nodenew-learningrecords.mobiloitte.io"; //live url new
// const url = "http://172.16.1.143:2122"; //Suraj sir local
// const url = "http://172.16.6.106:2122"; //Ashu sir local

// const url = "http://172.16.1.50:2055"; //Izhar local

// const url = "https://node-learningrecords.mobiloitte.io";
const challenges = "https://python.indicchain.com"; // Live
const resume = "https://python.indicchain.com"; // Live

const ApiConfig = {
  logIn: `${url}/api/v1/admin/logIn`,
  otpVerify: `${url}/api/v1/admin/otpVerify`,
  profile: `${url}/api/v1/admin/profile`,
  signUp: `${url}/api/v1/admin/signUp`,
  resetPassword: `${url}/api/v1/admin/resetPassword`,
  searchDataUproval: `${url}/api/v1/admin/searchDataUproval`,
  updateProfile: `${url}/api/v1/admin/toUprovedOrReject`,
  changeAll: `${url}/api/v1/admin/multiSelectToUprovedOrReject`,
  addUserData: `${url}/api/v1/automation/addUserData`,
  signUpBountyArray: `${url}/api/v1/automation/signUpBountyArray`,
  getTransaction: `${url}/api/v1/automation/getTransaction`,
  addAttandance: `${url}/api/v1/automation/addAttandance`,
  signUpBountyWithAttandance: `${url}/api/v1/automation/signUpBountyWithAttandance`,
  getSelfAssessment: `${url}/api/v1/admin/getSelfAssessment`,
  forgotPassword: `${url}/api/v1/admin/forgotPassword`,
  // otpVerify: `${url}/api/v1/admin/otpVerify`,
  changePassword: `${url}/api/v1/admin/changePassword`,
  getUserData: `${url}/api/v1/admin/getUserData`,
  getUserDataBlockChain: `${url}/api/v1/admin/getUserDataBlockChain`,
  getTransactionBlockChain: `${url}/api/v1/admin/getTransactionBlockChain`,
  getSelfAssessmentBlockChain: `${url}/api/v1/admin/getSelfAssessmentBlockChain`,
  getAttendanceBlockChain: `${url}/api/v1/admin/getAttendanceBlockChain`,
  getUserBadgeBlockChain: `${url}/api/v1/admin/getUserBadgeBlockChain`,
  mailSentInArray: `${url}/api/v1/admin/mailSentInArray`,
  resumeList: `${url}/api/v1/admin/resumeList`,
  resumeApproval: `${url}/api/v1/admin/resumeApproval`,
  viewFile: `${url}/api/v1/admin/viewFile`,
  createUserBadge: `${url}/api/v1/admin/createUserBadge`,
  employeeeList: `${url}/api/v1/admin/employeeeList`,
  employeeOtp: `${url}/api/v1/admin/employeeOtp`,
  employeeSignUp: `${url}/api/v1/admin/employeeSignUp`,
  employeeApproval: `${url}/api/v1/admin/employeeApproval`,
  employeeeBufferList: `${url}/api/v1/admin/employeeeBufferList`,
  import_excel: `${challenges}/import_excel/`,
  resumeAnalysis: `${resume}/resume_upload/up`,
  resumeAnalysisAWS: `${resume}/resume_upload/aws`,
  resumeAnalysisSearch: `${resume}/resume_upload/up_search`,
  resumeAnalysisAWSSearch: `${resume}/resume_upload/aws_search`,
  createUserBadgeArray: `${url}/api/v1/admin/createUserBadgeArray`,
  createCourse: `${url}/api/v1/course/createCourse`,
  listDomain: `${url}/api/v1/setting/listDomain`,
  listCourse: `${url}/api/v1/course/listCourse`,
  uploadIpfs: `${url}/api/v1/course/uploadIpfs`,
  uploadNFT: `${url}/api/v1/course/uploadNFT`,
  deleteCourse: `${url}/api/v1/course/deleteCourse`,
  getCourse: `${url}/api/v1/course/getCourse`,
  editCourse: `${url}/api/v1/course/editCourse`,
  addFaculty: `${url}/api/v1/admin/addFaculty`,
  facultyList: `${url}/api/v1/admin/facultyList`,
  getFaculty: `${url}/api/v1/admin/getFaculty`,
  createDegree: `${url}/api/v1/admin/createDegree`,
  listDegree: `${url}/api/v1/admin/listDegree`,
  deleteDegree: `${url}/api/v1/admin/deleteDegree`,
  updateDegree: `${url}/api/v1/admin/updateDegree`,
  dashboard: `${url}/api/v1/admin/dashboard`,

  updateFaculty: `${url}/api/v1/admin/updateFaculty`,
  deleteFaculty: `${url}/api/v1/admin/deleteFaculty`,
  createDomain: `${url}/api/v1/setting/createDomain`,
  deleteDomain: `${url}/api/v1/setting/deleteDomain`,
  getDomainByDegreeId: `${url}/api/v1/setting/getDomainByDegreeId`,

  editDomain: `${url}/api/v1/setting/editDomain`,
  getDomain: `${url}/api/v1/setting/getDomain`,
  facultyCourseList: `${url}/api/v1/course/facultyCourseList`,
  createSubject: `${url}/api/v1/course/createSubject`,
  listSubject: `${url}/api/v1/course/listSubject`,
  deleteSubject: `${url}/api/v1/course/deleteSubject`,
  viewSubject: `${url}/api/v1/course/viewSubject`,
  updateSubject: `${url}/api/v1/course/updateSubject`,
  listSubjectByDomainId: `${url}/api/v1/course/listSubjectByDomainId`,

  addTechnology: `${url}/api/v1/technology/addTechnology`,
  listTechnology: `${url}/api/v1/technology/listTechnology`,
  viewTechnology: `${url}/api/v1/technology/viewTechnology`,
  updateTechnology: `${url}/api/v1/technology/updateTechnology`,
  deleteTechnology: `${url}/api/v1/technology/deleteTechnology`,

  // course plan

  //university
  addUniversity: `${url}/api/v1/university/addUniversity`,
  editUniversity: `${url}/api/v1/university/editUniversity`,
  getUniversity: `${url}/api/v1/university/getUniversity`,
  listUniversity: `${url}/api/v1/university/listUniversity`,
  deleteUniversity: `${url}/api/v1/university/deleteUniversity`,
  addEnterPrise: `${url}/api/v1/enterprise/addEnterPrise`,
  listEnterprise: `${url}/api/v1/enterprise/listEnterprise`,
  deleteEnterprise: `${url}/api/v1/enterprise/deleteEnterprise`,
  getEnterprise: `${url}/api/v1/enterprise/getEnterprise`,
  editEnterprise: `${url}/api/v1/enterprise/editEnterprise`,
  addPrice: `${url}/api/v1/price/addPrice`,
  priceList: `${url}/api/v1/price/priceList`,
  priceDelete: `${url}/api/v1/price/priceDelete`,
  priceUpdate: `${url}/api/v1/price/priceUpdate`,
  priceView: `${url}/api/v1/price/priceView`,
  userList: `${url}/api/v1/admin/userList`,
  blockUnblockUser: `${url}/api/v1/admin/blockUnblockUser`,
  userTransactionList: `${url}/api/v1/admin/userTransactionList`,
  addSkills: `${url}/api/v1/skill/addSkills`,
  skillsList: `${url}/api/v1/skill/skillsList`,
  addSubSkills: `${url}/api/v1/skill/addSubSkills`,
  viewSkills: `${url}/api/v1/skill/viewSkills`,
  viewSubSkills: `${url}/api/v1/skill/viewSubSkills`,
  deleteSkills: `${url}/api/v1/skill/deleteSkills`,
  deleteSubSkills: `${url}/api/v1/skill/deleteSubSkills`,
  editSkills: `${url}/api/v1/skill/editSkills`,
  subskillsList: `${url}/api/v1/skill/subskillsList`,
  editSubSkills: `${url}/api/v1/skill/editSubSkills`,
  addSubAdmin: `${url}/api/v1/admin/addSubAdmin`,
  subadminList: `${url}/api/v1/admin/subadminList`,
  viewSubAdmin: `${url}/api/v1/admin/viewSubAdmin`,
  updateSubAdmin: `${url}/api/v1/admin/updateSubAdmin`,
  blockUnblockSubAdmin: `${url}/api/v1/admin/blockUnblockSubAdmin`,
  transactionList: `${url}/api/v1/admin/transactionList`,
  viewUser: `${url}/api/v1/admin/viewUser`,
  getLogs: `${url}/api/v1/admin/getLogs`,
  // profile: `${url}/api/v1/admin/profile`,
  listCertificate: `${url}/api/v1/certificate/listCertificate`,

  certificateView: `${url}/api/v1/certificate/certificateView/`,
  acceptReject: `${url}/api/v1/certificate/acceptReject`,
  // ticket query
  ticketList: `${url}/api/v1/ticket/ticketList`,
  updateTicketStatus: `${url}/api/v1/ticket/updateTicketStatus`,
  // Notification
  addAnnouncement: `${url}/api/v1/notification/addAnnouncement`,
  listAllUserForNotificaton: `${url}/api/v1/notification/listAllUserForNotificaton`,

  //Courses
  getAllCategory: `${url}/api/v1/course/getAllCategory`,
  createCategory: `${url}/api/v1/course/createCategory`,
  updateCategory: `${url}/api/v1/course/updateCategory`,
  deleteCategory: `${url}/api/v1/course/deleteCategory`,
  createSubCategory: `${url}/api/v1/course/createSubCategory`,
  getAllSubCategory: `${url}/api/v1/course/getAllSubCategory`,
  updateSubCategory: `${url}/api/v1/course/updateSubCategory`,
  deleteSubCategory: `${url}/api/v1/course/deleteSubCategory`,
};
export default ApiConfig;
